import { RoutePaths } from "./RoutePaths";

export const PagesWithoutFooter = [
    RoutePaths.Renew3DSConfirm.toLowerCase(),
    RoutePaths.Login.toLowerCase(),
    RoutePaths.ChoosePlan.toLowerCase(),
    RoutePaths.ConfirmSubscription.toLowerCase(),
];
